//配置全局访问接口地址
let commonUrl = "http://49.232.118.207:7070/websitemanager_v1/";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl


// WEBPACK FOOTER //
// ./src/interface.js